import { useState } from "react";
import { Link } from "react-router-dom";
import { fmtDate, tokens } from "@/lib/api";
import { EmailLookup } from "@/components/site/EmailLookup";
import { StatusBadge, RecruitmentDisclaimer } from "@/components/site/Notices";

export default function MyApplications() {
  const [apps, setApps] = useState(null);
  const onResult = (d) => {
    d.applications.forEach((a) => tokens.set("application", a.id, a.access_token));
    setApps(d.applications);
  };
  return (
    <div className="container-x py-16">
      <h1 className="text-4xl font-extrabold tracking-tight">My Applications</h1>
      <p className="mb-8 mt-3 text-slate-600">Verify the email you applied with to see status, receipts or continue an unfinished application.</p>
      <EmailLookup endpoint="/my/applications" onResult={onResult} testid="my-apps" />
      {apps && (
        <div className="mt-8 space-y-3" data-testid="my-apps-list">
          {apps.length === 0 && <p className="text-sm text-slate-500">No applications found for this email.</p>}
          {apps.map((a) => (
            <Link key={a.id} to={a.payment_status === "paid" ? `/application/${a.id}` : `/apply/${a.id}`} className="flex flex-wrap items-center justify-between gap-3 rounded-2xl border border-slate-200 bg-white p-5 hover:shadow-md" data-testid={`my-app-${a.reference}`}>
              <div><p className="font-mono-num font-bold">{a.reference}</p><p className="text-sm">{a.job_title}</p><p className="text-xs text-slate-500">Started {fmtDate(a.created_at)}{a.submitted_at ? ` · Submitted ${fmtDate(a.submitted_at)}` : ""}</p></div>
              <div className="flex items-center gap-2"><StatusBadge status={a.status} />{a.payment_status !== "paid" && <span className="text-xs font-semibold text-amber-700">Continue →</span>}</div>
            </Link>
          ))}
        </div>
      )}
      <RecruitmentDisclaimer className="mt-8" />
    </div>
  );
}
